import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import ChangeTable from './ChangeTable';
import { useAdminLogsContext } from './context/AdminLogsContext';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    // width: 500,
    // height: '60vh',
    // marginLeft: '16px',
    // marginRight: '16px',
    marginBottom: '16px',
  },
}));

export default function AdminLogsView() {
  const { logs: logData, tableActions, refreshAdminLogs, error: logErrors } = useAdminLogsContext({ mode: 'admin' });
  //TODO can this go into change table?, would need to specify table type... if seperating fetches then move it.
  // Run refreshAdminLogs on mount to get the latest unread count
  useEffect(() => {
    refreshAdminLogs();
    //eslint-disable-next-line
  }, []);

  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  return (
    <div className={classes.root}>
      <AppBar position="static" color="default">
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          aria-label="Client Change Logs"
        >
          <Tab label="Unread Logs" {...a11yProps(0)} />
          <Tab label="Archive" {...a11yProps(1)} />
        </Tabs>
      </AppBar>
      <SwipeableViews
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={value}
        onChangeIndex={handleChangeIndex}
      >
        <TabPanel value={value} index={0} dir={theme.direction}>
          <ChangeTable title="Unread Logs" logs={logData?.unread} tableActions={tableActions} logErrors={logErrors} />
        </TabPanel>
        <TabPanel value={value} index={1} dir={theme.direction}>
          <ChangeTable title="Archive" logs={logData?.read} tableActions={tableActions} logErrors={logErrors} />
        </TabPanel>
      </SwipeableViews>
    </div>
  );
}
